<template>
  <div v-if="card.infos?.length" class="list">
    <ListDisplay
      v-for="info in card.infos"
      :key="info.label"
      :title="info.label"
    >
      <template #value-slot>
        <Money>
          <BaseText size="md" as="p" :color="NebraskaColors.elementPrimary">
            {{ info.value }}
          </BaseText>
        </Money>
      </template>
    </ListDisplay>
  </div>
  <BaseText v-else v-bind="baseTextProps">
    {{ card.description }}
  </BaseText>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ListDisplay } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';

import {
  EProductViewCardType,
  IProduct
} from '@/modules/products/services/products';

interface Props {
  card: IProduct;
}
const props = defineProps<Props>();

const baseTextProps = computed(() =>
  props.card.type !== EProductViewCardType.Product
    ? {
        color: NebraskaColors.elementSecondary,
        class: 'default-footer'
      }
    : {
        color: NebraskaColors.elementPrimary
      }
);
</script>
<style lang="less" scoped>
.list {
  display: flex;
  flex-direction: column;
  gap: @size-spacing-x350;
}
.default-footer {
  width: 70%;
}
</style>
